import React, { useState, useEffect } from 'react';
import "./First1.css"
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
import { useNavigate } from 'react-router-dom'; // import navigate
import Allservices2 from './Allservices2';


const First1 = () => {

  const images = [
    '/animate1.png',
    '/animate2.png',
    '/animate3.png',
    '/animate4.png',
    '/animate5.png',
    '/animate6.png',
    '/animate7.png',
    '/animate8.png',
    '/animate9.png',
    '/animate10.png',
    '/animate11.png',
    '/animate12.png'

  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true); // Start bump animation
      setTimeout(() => setAnimate(false), 500); // Remove after animation duration

      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

const handleAnimationComplete = () => {
  console.log('Animation completed!');
};

  const navigate = useNavigate(); // initialize navigate

const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const handleSend = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_tzt9vkp',    // 🔁 Replace with your actual EmailJS service ID
      'template_h2ime3t',   // 🔁 Replace with your template ID
      { message },          // 🔁 Message object sent to email
      'VF0j5GQa3VdgvAIUA'     // 🔁 Replace with your EmailJS public key
    )
    .then((result) => {
      alert("Message sent successfully!");
      setMessage('');
    })
    .catch((error) => {
      alert("Failed to send message.");
      console.error(error);
    });
  };

   useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    });

    const elements = document.querySelectorAll('.scroll-animate');
    elements.forEach(el => observer.observe(el));
  }, []);


  return (
    <div>
<nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container-fluid">
    <img src="/logo.png" alt="logo" />
    <h5 className="mb-0">
      <span>SVT</span><br />
      DIGITAL INFO TECH
    </h5>

    {/* Toggler Button */}
    <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

    {/* Collapse menu */}
        <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
       <Link className="nav-link" to="/">
  <i className="fa-solid fa-house"></i> HOME
</Link>
        </li>

        <li className="nav-item dropdown">
        <Link
  className="nav-link dropdown-toggle"
  to="/allservices2"
  id="navbarDropdownMenuLink"
  role="button"
  data-bs-toggle="dropdown"
  aria-expanded="false"
>
  <i className="fa-solid fa-desktop" onClick={() => navigate('/allservices2')}
></i> SERVICES
</Link>

          <ul
            className="dropdown-menu p-3 custom-dropdown"
            aria-labelledby="navbarDropdownMenuLink"
            style={{ minWidth: '600px' }}
          >
            <div className="row">
              <div className="col-6">
<li>
  <Link className="dropdown-item" to="/website">
    <i className="fa-solid fa-desktop"></i> Website
  </Link>
</li>               <li>
  <Link className="dropdown-item" to="/graphicwork">
    <i className="fa-solid fa-fire"></i> Graphic Work
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/ecommerce">
    <i className="fa-solid fa-cart-shopping"></i> Ecommerce Development
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/software">
    <i className="fa-solid fa-tv"></i> Software Development
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/business">
    <i className="fa-solid fa-chart-line"></i> Business Consulting
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/erp">
    <i className="fa-solid fa-computer"></i> ERP Software
  </Link>
</li>
              </div>
              <div className="col-6">
               <li>
  <Link className="dropdown-item" to="/search">
    <i className="fa-solid fa-rocket"></i> Search Engine Optimization
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/digitalmarketing">
    <i className="fa-solid fa-satellite-dish"></i> Digital Marketing
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/socialmedia">
    <i className="fa-brands fa-hubspot"></i> Social Media Management
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/lead">
    <i className="fa-solid fa-network-wired"></i> Lead Generation
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/businessbrand">
    <i className="fa-solid fa-tag"></i> Business Branding
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/hr">
    <i className="fa-brands fa-searchengin"></i> HR Services
  </Link>
</li>
              </div>
            </div>
          </ul>
        </li>

        <li className="nav-item">
        <Link className="nav-link" to="/about">
  <i className="fa-solid fa-circle-info"></i> ABOUT US
</Link>
        </li>

        <li className="nav-item">
      <Link className="nav-link" to="/form">
  <i className="fa-solid fa-address-book"></i> CONTACT
</Link>
        </li>

      </ul>
    </div>
  </div>
</nav>

<div className='first'>

  <div className='tables'>
  <h1>
  DIGIT<span className="shine-letter">ALL</span> SERVICES
</h1>
</div> 
<div className='firsts'>
  
  <div className='table1 scroll-animate'>
  <h4>“We craft your digital presence with style and strategy,<br/> From design to marketing, we make your brand shine.”</h4>
     <div className='cer scroll-animate'>
     <img src='/img1.png' alt=''/>
     <img src='/img2.png' alt=''/>
    <img src='/img3.png' alt=''/>
     </div>
  </div>

  {/* <div className='table2'>
<img src='/animate1.png' alt='' />

  </div> */}

    <div className="table2">
      <div>
      <img
        src={images[currentIndex]}
        alt="Animated"
        className={`bump-img ${animate ? 'bump' : ''}`}
      />
      </div>
    <hr class="fancy-hr" />

    </div>
</div>
<div className='button-wrapper'> 
<button className='btns scroll-animate' onClick={() => navigate('/form')}>
  START YOUR PROJECT <i className="fa-solid fa-circle-arrow-right"></i>
</button></div>
</div>


<div className='content scroll-animate '>
    <h4>SVT Digital Info Tech is a forward-thinking digital services and training institute based in Tirupur, Tamil Nadu, committed to shaping future-ready professionals through industry-driven education and real-world training.<br/>
Founded with a vision to bridge the skill gap between education and employment, SVT Digital Info Tech offers high-quality training programs designed to meet the evolving needs of today's digital economy.</h4>

<h4 className='two'>Our expert trainers with 10+ years of industry experience provide practical and theoretical learning. Whether you're a student, job-seeker, or professional, SVT Digital Info Tech helps you upskill for success in the digital world.</h4>

<div class="container">
    <div class="center-row">
  <div class="row">
    <div class="col-sm-6 mb-3" className='responsive-card scroll-animate' >
      <div class="card h-100">
        <div class="card-body news">
          <h5 class="card-title">OUR MISSION<img src='/mission.png' alt='' /></h5>
          <p class="card-text"><i class="fa-solid fa-star"></i>To empower learners with industry-relevant skills through practical, high-quality education.</p>
          <p class="card-text"><i class="fa-solid fa-star"></i>To bridge the gap between academic knowledge and real-world application for career growth.</p>
        </div>
      </div>
    </div>

    <div class="col-sm-6 mb-3"  className='responsive-card scroll-animate' >
      <div class="card h-100">
        <div class="card-body news">
          <h5 class="card-title">OUR VISSION<img src='/vission.png' alt='' /></h5>
          <p class="card-text"><i class="fa-solid fa-star"></i>To be a leading institution recognized for excellence in skill-based learning and innovation.</p>
          <p class="card-text"><i class="fa-solid fa-star"></i>To create a global community of confident, capable professionals ready to shape the future.</p>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>

</div>

<div className='nextcont scroll-animate'>
<h1>Our Popular Services</h1>
<div className='nextcont1 scroll-animate'>
<img src='/conts.png' alt=''  className='custom-imgs'/>
</div>
</div>

<div className='abovefoot scroll-animate'>

  <div>
     <h3>Let's Get In Touch</h3>
     <h5>For Business Related Enquiries </h5>
     <div className='details scroll-animate'>
      <div className='div1'><i class="fa-solid fa-phone"></i><a href='#' >9916828514</a></div>
      <div className='div1'><i class="fa-solid fa-envelope"></i><a href='#' >svtdigiinfo@gmail.com</a></div>
     </div>

       <div className='details1 scroll-animate'>
      <div className='div1'><i class="fa-solid fa-phone"></i><a href='#' >9655473531</a></div>
      <div className='div1'><i class="fa-solid fa-globe"></i><a href='#' >www.svtdigiinfotech.in</a></div>
     </div>
<div className="map-container scroll-animate">
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3914.7667864816963!2d77.34702699509769!3d11.130739036988123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba90645f35196f1%3A0x119a4f2330000000!2sSVT%20Digital%20Info%20Tech!5e0!3m2!1sen!2sin!4v1751614160817!5m2!1sen!2sin" width="450" height="455" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>



  </div>

<div>
  <div className="contact-box scroll-animate">
      <h2>Support & Contact</h2>
      <p>Enter your details we will<br />connect you Soon</p>
      <form>
        <div className="row mb-3">
          <div className="col-12 col-md-6 mb-2 mb-md-0">
            <input type="text" className="form-control" placeholder="Your Name" required />
          </div>
          <div className="col-12 col-md-6">
            <input type="email" className="form-control" placeholder="Your Email" required />
          </div>
        </div>
        <div className="mb-3">
          <input type="tel" className="form-control" placeholder="Mobile No" required />
        </div>
        <div className="mb-3">
          <textarea className="form-control" rows="4" placeholder="Your Message" required></textarea>
        </div>
        <button type="submit" className="btn btn-custom" onClick={() => navigate('/form')}>START YOUR PROJECT<i className="fa-solid fa-circle-arrow-right"></i></button>
      </form>
    </div>
</div>
</div>


<footer class="bg-dark text-white pt-4 pb-2 scroll-animate">
<div style={{ position: '', width: '100%', height: 'auto', overflow: 'hidden' }}>


  <div class="container text-center text-md-left">
    <div class="row">

    
<div class="col-md-4 mb-3 d-flex flex-column align-items-center scroll-animate">
  <h3 class="text-center">QUICK LINKS</h3>
  <ul class="quick-links list-unstyled text-center p-0 m-0">
    <li><a href="/" class="text-white text-decoration-none d-block mb-1">Website Designing </a></li>
    <li><a href="/courses" class="text-white text-decoration-none d-block mb-1">Graphic Work</a></li>
    <li><a href="/contact" class="text-white text-decoration-none d-block mb-1">E-Commerce Development</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Software Development</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Business Consulting</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">ERP Software</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Search Engine Optimization</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Digital Marketing</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Social Media Management</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Lead Generation</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Business Branding</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">HR Services</a></li>
  </ul>
</div>


<div class="col-md-4 mb-3 scroll-animate">
  <h3 class="text-center">ADDRESS</h3>
  <p class="contact-info text-start">
    📍 Kongu Main Rd, near Bharat Petrol Bunk, MS Nagar, Tiruppur, Tamil Nadu 641607<br/>
    📞 99168 28514<br/>
    📧 svtdigiinfo@gmail.com
  </p>
</div>

 <div class="col-md-4 mb-3 scroll-animate">
    <h3> SOCIAL MEDIA</h3>

<div>
<a
  href="https://wa.me/919916828514"  
  target="_blank"
  rel="noopener noreferrer"
>
<i class="fa-brands fa-whatsapp"></i>
</a>
<a href="https://www.facebook.com/profile.php?id=61575077092918" target="_blank">
  <i class="fa-brands fa-facebook"></i>
</a>
</div>
<div className='second'>
<a href="https://www.instagram.com/svt_digital_academy/" target="_blank">
  <i class="fa-brands fa-instagram"></i>
</a> 

<a href="https://www.youtube.com/@SVTDigitalinfotech" target="_blank">
  <i class="fa-brands fa-youtube"></i>
</a>
</div>

      </div>

    </div>

    <hr class="custom-hr" />


    <div class=" mt-3 scroll-animate">
      <h5>Terms and condition | <Link to="/privacy" className="customlink">Privacy policy</Link>
 <br/>
Copyright ©svt digital info tech. All Rights Reserved.</h5>
    </div>

  </div>
  </div>

</footer>

  <div className="chat-wrapper">
  {/* Floating Text */}
  {!isOpen && <div className="floating-label">Chat with us</div>}

  {/* Toggle button */}
  <button className="chat-toggle" onClick={() => setIsOpen(!isOpen)}>
    💬
  </button>

  {/* Chat window */}
  {isOpen && (
    <div className="chat-box">
      <div className="chat-header">
        <h5>Chat with Us</h5>
        <button onClick={() => setIsOpen(false)}>✖</button>
      </div>

      <div className="chat-body">
        <p>Hello! How can we help you?</p>
      </div>

      <div className="chat-footer">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message..."
        />
        <button onClick={handleSend}>Send</button>
      </div>
    </div>
  )}
</div>



<a
  href="https://wa.me/919916828514" // 🔁 Replace with your number
  className="whatsapp-float"
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fa-brands fa-whatsapp"></i>
</a>

    </div>
  )
}

export default First1
